import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Sidebar } from "@/components/Sidebar";
import Dashboard from "@/pages/Dashboard";
import Todos from "@/pages/Todos";
import Shopping from "@/pages/Shopping";
import CalendarPage from "@/pages/CalendarPage";
import Notes from "@/pages/Notes";
import Diary from "@/pages/Diary";
import Login from "@/pages/Login";
import Profile from "@/pages/Profile";
import SharePage from "@/pages/SharePage";
import PublicWishlist from "@/pages/PublicWishlist";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordReset";
import { ThemeProvider } from "@/lib/theme";
import { AuthProvider, useAuth } from "@/lib/auth";
import { AuthCallback } from "@/components/AuthCallback";
import { GuestBanner } from "@/components/GuestBanner";
import { LogoLoader } from "@/components/Logo";

const Loading = LogoLoader;

const Shell = () => {
  const { user } = useAuth();
  if (!user) return <Loading />;
  return (
    <div className="relative flex flex-col lg:flex-row min-h-screen">
      <Sidebar />
      <main className="relative z-10 flex-1 min-w-0 px-5 sm:px-8 lg:px-14 py-8 lg:py-14 max-w-[1400px]">
        <GuestBanner />
        <Routes key={user.user_id}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/todos" element={<Todos />} />
          <Route path="/lists" element={<Shopping />} />
          <Route path="/calendar" element={<CalendarPage />} />
          <Route path="/notes" element={<Notes />} />
          <Route path="/diary" element={<Diary />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/settings" element={<Profile />} />
          <Route path="/share" element={<SharePage />} />
        </Routes>
      </main>
    </div>
  );
};

const AppRouter = () => {
  const location = useLocation();
  const { user } = useAuth();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  if (location.pathname.startsWith("/w/")) return <Routes><Route path="/w/:token" element={<PublicWishlist />} /></Routes>;
  if (location.pathname === "/login") return user ? <Login /> : <Loading />;
  if (location.pathname === "/forgot-password") return <ForgotPassword />;
  if (location.pathname === "/reset-password") return <ResetPassword />;
  return <Shell />;
};

function App() {
  return (
    <ThemeProvider>
    <AuthProvider>
    <div className="App grain">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster position="bottom-right" toastOptions={{ style: { background: "rgb(var(--t-ink))", color: "rgb(var(--t-bg))", border: "none" }, classNames: { description: "!text-inherit opacity-80" } }} />
    </div>
    </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
